__turbopack_context__.v({
  "className": "lora_af2b2611-module__yikrka__className",
  "variable": "lora_af2b2611-module__yikrka__variable",
});
